module.exports = __webpack_public_path__ + "img/olympus.413a442d.svg";